export const FEATURE_FLAG_NAMES = [
  'ABC-000-unit-tests-flag', // do not delete
  'PPL-2119-paid-break-exception',
  'PPL-2300-signature-as-array-of-strings',
  'PPL-2240-verify-timesheet-action',
] as const;

export const DEFAULT_FEATURE_FLAG_TREATMENT_ENABLED_VALUE = 'on';

export type FeatureFlagName = (typeof FEATURE_FLAG_NAMES)[number];

export type FeatureFlagAttributes = {
  clientId?: string;
};
